module.exports = __webpack_public_path__ + "static/media/manage-vendors.82e308d2.svg";